exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2GkVCrmbf_MEeaGjgQ43n1 a{color:dycolor-internal(!info-text,@theme-white)}._2GkVCrmbf_MEeaGjgQ43n1 .v-autocomplete .v-autocomplete-input{border-bottom:1px solid dycolor-internal(!autocomplete-border,@theme-dark-grey)}._2GkVCrmbf_MEeaGjgQ43n1 .v-autocomplete .v-autocomplete-list{background:dycolor-internal(!autocomplete-results-background,@theme-light-grey)}._2GkVCrmbf_MEeaGjgQ43n1 .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item{color:dycolor-internal(!pagination-text,@theme-black)}._2GkVCrmbf_MEeaGjgQ43n1 .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:hover{background:dycolor-internal(!autocomplete-list-hover,@theme-white)}@media (min-width: 992px){._2GkVCrmbf_MEeaGjgQ43n1 .v-autocomplete .v-autocomplete-list{border:1px solid dycolor-internal(!autocomplete-results-border-bottom,@theme-light-grey)}._2GkVCrmbf_MEeaGjgQ43n1 .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:hover{background:dycolor-internal(!autocomplete-results-background-hover,@theme-white)}}\n", ""]);

// exports
exports.locals = {
	"root": "_2GkVCrmbf_MEeaGjgQ43n1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/facebook-page/FacebookPage.scss
// module id = 900
// module chunks = 1